module.exports = __webpack_public_path__ + "img/运动康养_1@2x.6e2f300c.png";